import React from 'react';
import { Chip } from '../../lib/types';
import Modal, { ModalTitle, ModalSubtitle, ModalActions } from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';

interface RemoveChipFromPetModalProps {
  open: boolean;
  onClose: () => void;
  chip: Chip | null;
  onRemove: (chipId: string) => void;
}

export default function RemoveChipFromPetModal({ open, onClose, chip, onRemove }: RemoveChipFromPetModalProps) {
  if (!chip) {
    return null;
  }

  function handleConfirm() {
    onRemove(chip!.id);
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle>Remove chip from pet</ModalTitle>
      <ModalSubtitle>
        Are you sure you want to remove chip <strong>{chip.id}</strong>
        {chip.petName ? ` from ${chip.petName}` : ''}? Pet and owner information will be cleared and the chip will be
        returned to your stock.
      </ModalSubtitle>
      <ModalActions>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Remove
        </Button>
      </ModalActions>
    </Modal>
  );
}
